import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * settings-retrieve operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const retrieveSettings = async ({
  request,
}: {
  request: ApiTypes["settings-retrieve"]["request"];
}): Promise<ApiTypes["settings-retrieve"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["settings-retrieve"]["response"]
    >(`/api/public/v2025-06/settings`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to retrieveSettings");
    throw error;
  }
};
